const SkillsData = ['HTML', 'CSS', 'JavaScript', 'React', 'TypeScript', 'API', 'Routers', 'Tailwind', 'Extensions', 'Node.js', 'Zustand','OOP']

export default SkillsData